<p-toast></p-toast>

<!-- Page Header -->
<div class="page-header">
  <h1 class="page-title">Photos</h1>
  <div class="header-actions">
    <button class="btn-outline" type="button" (click)="toggleSortBy()">
      <span>Sort by {{ sortBy === 'date' ? 'MV Power Station' : 'Date' }}</span>
    </button>
    @if (canUpload) {
    <button class="btn-primary" type="button" (click)="showAddPhotoDialog = true" [disabled]="isProjectInactive">
      <i class="ri-add-line"></i>
      <span>New Photo</span>
    </button>
    }
    @if (canDelete) {
    <p-menu #menu [model]="actionItems" [popup]="true" appendTo="body" />
    <button class="btn-icon-only" type="button" (click)="menu.toggle($event)" [disabled]="isProjectInactive">
      <i class="ri-more-2-line"></i>
    </button>
    }
  </div>
</div>

<p-menu #photoDownloadMenu [model]="photoDownloadMenuItems" [popup]="true" appendTo="body"></p-menu>

<!-- Photos Body -->
<div class="photos-body">

  <!-- Uploading Photos -->
  @if (uploadingPhotos.length > 0) {
  <div class="date-section">
    <div class="date-header">
      <span class="date-label uploading-label">Uploading...</span>
      <div class="date-divider"></div>
    </div>
    <div class="photos-grid">
      @for (uploadingPhoto of uploadingPhotos; track uploadingPhoto.id) {
      <div class="photo-card">
        <img [src]="uploadingPhoto.localPreviewUrl" [alt]="uploadingPhoto.file.name" class="photo-image" />
        <div class="upload-overlay">
          @if (uploadingPhoto.status === 'uploading' || uploadingPhoto.status === 'pending') {
          <p-progressBar [value]="uploadingPhoto.progress || 0" [showValue]="false"
            [style]="{'height': '4px', 'border-radius': '0'}" mode="indeterminate">
          </p-progressBar>
          }
          @if (uploadingPhoto.status === 'error') {
          <i class="ri-error-warning-line upload-status-icon error"></i>
          }
          @if (uploadingPhoto.status === 'completed') {
          <i class="ri-checkbox-circle-line upload-status-icon success"></i>
          }
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- Photos by Date -->
  @if (sortBy === 'date') {
  @for (date of groupedPhotoDates; track date) {
  <div class="date-section">
    <div class="date-header">
      <span class="date-label">{{ date }}</span>
      <div class="date-divider"></div>
    </div>
    <div class="photos-grid">
      @for (photo of groupedPhotosByDate[date]; track photo.photoId) {
      <div class="photo-card" [class.selected]="isPhotoSelected(photo)" (click)="openPhotoInViewer(photo)">
        <img [src]="getPhotoUrl(photo)" [appMediaFallback]="photo.thumbnailPath" [appMediaFallbackAlternate]="photo.photoPath" [alt]="photo.photoName || 'Photo'" class="photo-image" loading="lazy"
          decoding="async" />
        @if (photo.sourceType === 'Skid') {
        <div class="photo-source-tag tag-skid photo-skid-tag">
          <span class="photo-skid-title">{{ getPhotoSourceLabel(photo) }}</span>
          @if (getPhotoSkidSubtitle(photo)) {
          <span class="photo-skid-subtitle">{{ getPhotoSkidSubtitle(photo) }}</span>
          }
        </div>
        } @else {
        <span class="photo-source-tag">Project</span>
        }
        @if (canDelete) {
        <div class="photo-checkbox" [class.checked]="isPhotoSelected(photo)"
          (click)="togglePhotoSelection($event, photo)">
          @if (isPhotoSelected(photo)) {
          <i class="ri-check-line"></i>
          }
        </div>
        }
        <div class="photo-overlay">
          <div class="photo-actions">
            <button class="overlay-btn" type="button" (click)="$event.stopPropagation(); openPhotoInViewer(photo)"
              title="View">
              <i class="ri-eye-line"></i>
            </button>
            <button class="overlay-btn" type="button"
              (click)="openPhotoDownloadMenu($event, photo, photoDownloadMenu)" title="Download">
              <i class="ri-download-line"></i>
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  }
  }

  <!-- Photos by MV Power Station -->
  @if (sortBy === 'skid') {
  @for (skidKey of groupedSkidKeys; track skidKey) {
  <div class="date-section">
    <div class="date-header">
      <span class="date-label">{{ skidKey }}</span>
      <div class="date-divider"></div>
    </div>
    <div class="photos-grid">
      @for (photo of groupedPhotosBySkid[skidKey]; track photo.photoId) {
      <div class="photo-card" [class.selected]="isPhotoSelected(photo)" (click)="openPhotoInViewer(photo)">
        <img [src]="getPhotoUrl(photo)" [appMediaFallback]="photo.thumbnailPath" [appMediaFallbackAlternate]="photo.photoPath" [alt]="photo.photoName || 'Photo'" class="photo-image" loading="lazy"
          decoding="async" />
        @if (photo.sourceType === 'Skid') {
        <div class="photo-source-tag tag-skid photo-skid-tag">
          <span class="photo-skid-title">{{ getPhotoSourceLabel(photo) }}</span>
          @if (getPhotoSkidSubtitle(photo)) {
          <span class="photo-skid-subtitle">{{ getPhotoSkidSubtitle(photo) }}</span>
          }
        </div>
        } @else {
        <span class="photo-source-tag">Project</span>
        }
        @if (canDelete) {
        <div class="photo-checkbox" [class.checked]="isPhotoSelected(photo)"
          (click)="togglePhotoSelection($event, photo)">
          @if (isPhotoSelected(photo)) {
          <i class="ri-check-line"></i>
          }
        </div>
        }
        <div class="photo-overlay">
          <div class="photo-actions">
            <button class="overlay-btn" type="button" (click)="$event.stopPropagation(); openPhotoInViewer(photo)"
              title="View">
              <i class="ri-eye-line"></i>
            </button>
            <button class="overlay-btn" type="button"
              (click)="openPhotoDownloadMenu($event, photo, photoDownloadMenu)" title="Download">
              <i class="ri-download-line"></i>
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  }
  }

  @if (unifiedPhotoList.length === 0 && uploadingPhotos.length === 0) {
  <div class="empty-state">
    <i class="ri-image-line"></i>
    <p class="empty-title">No photos yet</p>
    <p class="empty-subtitle">Upload photos to get started</p>
  </div>
  }

  @if (hiddenPhotoCount > 0) {
  <div #loadMoreSentinel class="load-more-photos" aria-live="polite">
    <span>Showing {{ visiblePhotoCount }} of {{ unifiedPhotoList.length }} photos</span>
    <span>Loading more as you scroll...</span>
  </div>
  }

</div>

<!-- Upload Photos Dialog -->
<p-dialog
  header="Upload Photos"
  [modal]="true"
  [(visible)]="showAddPhotoDialog"
  [style]="{ width: '50rem' }"
  [contentStyle]="{ overflow: 'hidden', padding: '0' }"
  styleClass="kansei-dialog photos-upload-dialog">
  <div class="upload-photo-dialog">
    <div class="upload-photo-content">
      <div class="fileupload-modal-wrapper">
        <p-fileupload
          class="fileupload-full"
          name="demo[]"
          customUpload="true"
          showUploadButton="false"
          [accept]="supportedPhotoAccept"
          [multiple]="true"
          maxFileSize="524288000"
          mode="advanced"
          (onSelect)="onFileSelect($event)"
          (onRemove)="onFileRemove($event)"
          (onClear)="onFileClear()"
          [disabled]="!canUpload || isProjectInactive">
          <ng-template #empty>
            <div>Drag and drop photos here to upload.</div>
          </ng-template>
        </p-fileupload>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="modal-btn-cancel" (click)="showAddPhotoDialog = false">Cancel</button>
      <button type="button" class="modal-btn-primary" (click)="addPhoto()" [disabled]="!canUpload || isProjectInactive">Save</button>
    </div>
  </div>
</p-dialog>
